export default __webpack_public_path__ + "static/media/basic-attention-token-bat-logo.26c9b1d3.svg";